// extracted by mini-css-extract-plugin
module.exports = {"orderAttribute":"OrderAttributeTextInput_orderAttribute__xr3Nn","field":"OrderAttributeTextInput_field__S5Ke2"};